import { cn, getContrastTextClass } from '../../lib/utils';
import { resolveValuePresentation, LucideIconByName } from '../../utils/periodizationValueSchema';

const AttributeValueBadge = ({ value, type, className, compact = false }) => {
  const pres = resolveValuePresentation(value, type);
  if (pres.label === '—' && value == null) {
    return <span className={cn('text-muted-foreground text-xs', className)}>—</span>;
  }
  const bg = pres.backgroundColor || 'hsl(var(--muted))';
  const textClass = pres.backgroundColor ? getContrastTextClass(pres.backgroundColor) : 'text-foreground';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium tabular-nums',
        textClass,
        className
      )}
      style={{ backgroundColor: bg }}
      title={pres.label}
    >
      {pres.icon && type?.value_schema?.config?.display?.show_icon !== false && (
        <LucideIconByName name={pres.icon} className='h-3 w-3 shrink-0' />
      )}
      <span className={compact ? 'truncate max-w-[4rem]' : ''}>{pres.shortLabel}</span>
    </span>
  );
};

export default AttributeValueBadge;
